import { getConfig } from 'EnvConfig'

const isLocalDevHost = (hostname: string) =>
  hostname === 'localhost' ||
  hostname === '127.0.0.1' ||
  hostname === '::1' ||
  hostname === '[::1]'

export const getEcpDomain = (): string => {
  const pathWithoutQueryData = window.location.href.split('?')[0]

  if (window.AppShell) {
    return window.AppShell.portalDomain
  }

  return isLocalDevHost(window.location.hostname)
    ? getConfig().DEPLOYED_ECP_URL
    : pathWithoutQueryData
}
